/**
 * @Author: v_jppjpeng
 * @Date: 2023-05-23 19:56:51
 * @Explain: 登录、注册、忘记密码
 */

// 登录
export type LoginFormDataType = {
  accountName: string;
  password: string;
  captchaToken?: string;
};

// 登录模式
export enum LoginModeEnum {
  default = 'default',
  session_time_out = 'session_time_out',
}
/** 登录类型 */
export enum LoginTypeEnum {
  /** 系统登录 */
  SYSTEM = 'system',
  /** 玉符 */
  YUFU = 'yufu',
  /** woa */
  WOA = 'woa',
}
/** 登录状态 */
export enum LoginStatusEnum {
  INIT = 'intl',
  /** 已登录 */
  SIGNED_IN = 'signedIn',
  /** 未登录 */
  NOT_LOGGED_IN = 'notLoggedIn',
  /** 登录失败 */
  LOGIN_FAIL = 'loginFail',
}

// 注册
export type RegisterFormDataType = {
  email: string;
  code: string;
  accountName: string;
  password: string;
  agreementOne: boolean;
  agreementTwo: boolean;
};

// 忘记密码
export type ForgotPwFormDataType = {
  email: string;
  code: string;
  password: string;
  rePassword: string;
};

/** 登录后 - 渲染类型 */
export enum AfterLoginRenderTypeEnum {
  /** 新用户 - 邀请加入项目 */
  NEW_USER = 'new_user',
  /** 未加入项目 */
  NOT_JOIN_PROJECT = 'not_join_project',
  /** 不是新用户 - 邀请加入项目 */
  INVITER_JOIN_PROJECT = 'inviter_join_project',
}
